import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Image, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import UserSVG from '../../../assets/images/help-desk/user.svg';

const SelectRequest = ({ requestType }) => {

    return (

        <React.Fragment>

            {requestType !== 'newRequest' && requestType.split(',')[1] !== 'removeRequest' &&
                <React.Fragment>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap justify-content-end position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards'
                        }}>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-left-0`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-dark)'
                            }}>
                            {requestType.split(',')[1] === 'modifyRoom' &&
                                <Typography
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    درخواست تغییر یا حذف اتاق
                                </Typography>
                            }
                            {requestType.split(',')[1] === 'cancel' &&
                                <Typography
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    درخواست کنسل کردن رزرو
                                </Typography>
                            }
                            {requestType.split(',')[1] === 'modifyDate' &&
                                <Typography
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    درخواست تغییر تاریخ رزرو
                                </Typography>
                            }
                            {requestType.split(',')[1] === 'extraPassenger' &&
                                <Typography
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    درخواست افزودن نفر اضافه
                                </Typography>
                            }
                            {requestType.split(',')[1] === 'halfCharge' &&
                                <Typography
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    درخواست افزودن نیم شارژ
                                </Typography>
                            }
                            {requestType.split(',')[1] === 'hotelInfo' &&
                                <Typography
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    درخواست اطلاعات هتل
                                </Typography>
                            }
                            {requestType.split(',')[1] === 'modifyPassenger' &&
                                <Typography
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    درخواست تغییر اطلاعات مسافران
                                </Typography>
                            }
                            {requestType.split(',')[1] === 'invoice' &&
                                <Typography
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    درخواست فاکتور رسمی
                                </Typography>
                            }
                            {requestType.split(',')[1] === 'transfer' &&
                                <Typography
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    درخواست ترنسفر
                                </Typography>
                            }
                        </Box>
                        <Box
                            className={`mx-xs ml-0 my-sm mb-0 rounded-circle`}>
                            <Image
                                src={UserSVG}
                                alt='info'
                                ms={{
                                    width: '18px',
                                    height: '18px'
                                }} />
                        </Box>
                    </Box>
                </React.Fragment>
            }

        </React.Fragment>

    );

}

export default SelectRequest;